import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "product/model"

class service {

    getModelsByGroupProductId(groupProductId) {

        if (groupProductId > 0) {

            let params = new URLSearchParams()
            params.set("status", "1")
            params.set("groupProductId", groupProductId)

            return this.selectList(params)

        }

    }

    getForceReadById(id){
        return http.getById(path,id,true).then(response => response.data);
    }

    selectList(params) {
        return http.list(path + "/selectList", params);
    }


}

export default new service();

